import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
} from "react";
import type { FieldsHolderType } from "./transform";

export type WatchedFieldContextType = {
  setWatchedFields: Dispatch<SetStateAction<FieldsHolderType>>;
  watchedFields: FieldsHolderType | null;
};

export const WatchedFieldContext = createContext<WatchedFieldContextType>({
  setWatchedFields: () => {},
  watchedFields: null,
});

export function useWatchedFields() {
  const context = useContext(WatchedFieldContext);
  if (context === undefined) {
    throw new Error(
      "useWatchedFields must be used within a WatchedFieldProvider",
    );
  }
  return context;
}
